<template>
    <div class="col-md-12">
        <div class="row">
        </div>
        <div class="position-relative pagination-control table-hover">
            <data-table
                :columns="columns"
                :url="tableUrl"
                :per-page="perPage"
                :order-by="orderBy"
                :order-dir="orderDir"
                :meta="columns.meta"
                :classes="classes"
                :translate="translate"
                :filters="filters"
                :debounce-delay=1000
                ref="table"
            >
                <div slot="filters" slot-scope="{ tableFilters, perPage, bookings }">
                    <div class="row my-3">
                        <div class="col-md-6">
                            <div class="h2">Performance</div>
                        </div>

                        <div class="col-md-2">
                            <div class="align-items-center bg-white border rounded-lg div-focus">
                                <v-select
                                    :options="typeOptions"
                                    v-model="filters.types"
                                    label="label"
                                    multiple="multiple"
                                    id="v-select-larger"
                                    placeholder="Select types"
                                >
                                </v-select>
                            </div>
                        </div>

                        <div class="col-md-2">
                            <div
                                class="d-flex align-items-center bg-white border rounded-lg div-focus border-2">
                                <date-picker v-model="filters.dateFrom"
                                             valueType="YYYY-MM-DD"
                                             input-class="border-0 py-0 shadow-none form-input"
                                             placeholder="from"
                                             :lang="datePickerOptions.lang"
                                             format="DD/MM/YYYY">
                                </date-picker>
                            </div>
                        </div>

                        <div class="col-md-2">
                            <div
                                class="d-flex align-items-center bg-white border rounded-lg div-focus border-2">
                                <date-picker v-model="filters.dateTo"
                                             valueType="YYYY-MM-DD"
                                             input-class="border-0 py-0 shadow-none form-input"
                                             placeholder="to"
                                             :lang="datePickerOptions.lang"
                                             format="DD/MM/YYYY">
                                </date-picker>
                            </div>
                        </div>
                    </div>
                </div>
                <thead class="clickable-header" slot="header" slot-scope="{ tableFilters }">
                <tr>
                    <th @click="sort(column.id)"
                        v-for="column in columns">
                        <span> {{ column.label }}  </span>
                    </th>
                </tr>
                </thead>
                <tbody slot="body" slot-scope="{ data }">
                <tr :key="item.id"
                    v-for="item in data">
                    <td :key="column.name"
                        v-for="column in columns"
                        class="laravel-vue-datatable-td border-0 text-left py-2 font-weight-normal"
                    >
                        <data-table-cell
                            :value="item"
                            :name="column.name"
                            :meta="column.meta"
                            :comp="column.component"
                            :classes="column.classes">
                        </data-table-cell>

                        <slot v-if="column.label === 'Time'">
                            {{ types[item.type]['time'] }}
                        </slot>
                        <slot v-if="column.id === 'type'">
                            {{ types[item.type]['name_alt'] ?? '' }}
                        </slot>
                        <slot v-if="column.id === 'costWithFees'">
                            <span v-if="!item.driverFeesTotal == 0 && rowShouldIncludeDriverFees(item)"
                                  class="text-primary"
                                  :title="getPriceHoverTitle(item)"
                            >{{ item.costWithFees }}</span>
                            <span v-else>{{ item.cost }}</span>
                        </slot>

                        <slot v-if="column.id === 'driverFeesJsonTotal'">
                            <span v-if="!((Number(item.driverFeesJsonTotal) || 0) === 0) && rowShouldIncludeDriverFees(item)"
                                  class="text-primary"
                            >{{ item.driverFeesJsonTotal }}</span>
                            <span v-else></span>
                        </slot>

                        <slot v-if="column.id === 'driverBonusesJsonTotal'">
                            <span v-if="!((Number(item.driverBonusesJsonTotal) || 0) === 0) && rowShouldIncludeDriverFees(item)"
                                  class="text-primary"
                            >{{ item.driverBonusesJsonTotal }}</span>
                            <span v-else></span>
                        </slot>

                        <slot v-if="column.id === 'profitWithFees'">
                            <span v-if="!item.driverFeesTotal == 0 && rowShouldIncludeDriverFees(item)"
                                  class="text-primary"
                                  :title="getProfitHoverTitle(item)"
                            >{{ item.profitWithFees }}</span>
                            <span v-else>{{ item.profit }}</span>
                        </slot>

                    </td>
                </tr>
                </tbody>

                <div slot="pagination" slot-scope="{ links, meta }"
                     class="d-flex justify-content-between align-items-center"
                >
                    <div>
                        <label class="pr-2">Per page:</label>
                        <div class="d-inline-flex align-items-center bg-white border rounded-lg div-focus border-2">
                            <select class="form-control bg-white border-0 py-0 shadow-none " v-model="filters.length"
                                    style="width: 150px;">
                                <option
                                    :key="index"
                                    :value="records"
                                    v-for="(records, index) in perPage">
                                    {{ records }}
                                </option>
                            </select>
                        </div>
                    </div>
                    <pagination
                        ref="pagination"
                        :total-pages="meta.last_page"
                        :current-page-prop="meta.current_page"
                        v-if="meta && meta.last_page > 1"
                    ></pagination>
                </div>
            </data-table>
        </div>
        <loading :active.sync="isLoading"
                 :can-cancel="false"
                 :is-full-page="true">
        </loading>
    </div>
</template>

<script>
import 'vue-loading-overlay/dist/vue-loading.css';
import Loading from "vue-loading-overlay";
import datePickerOptionsMixin from "../../mixins/datePickerOptionsMixin";
import Pagination from "./../reusable/Pagination.vue";
import dataTablePaginationMixin from "../../mixins/dataTablePaginationMixin";

export default {
    components: {Loading, Pagination},
    mixins: [datePickerOptionsMixin, dataTablePaginationMixin],
    name: "Performance",
    props: {
        url: {type: String, required: true},
        types: {type: Object, required: true}
    },
    computed: {
        currentPage() {
            return this.$refs.table.tableData.meta ? this.$refs.table.tableData.meta.current_page : 1;
        },
    },
    data() {
        return {
            tableUrl: this.url,
            isLoading: false,
            perPage: [25, 10, 50, 100],
            orderBy: "id",
            orderDir: "desc",
            columns: [
                {
                    label: 'Time',
                    id: 'time',
                    orderable: false
                },
                {
                    label: 'Type',
                    id: 'type',
                    orderable: false,
                },
                {
                    label: 'Date',
                    id: 'date',
                    name: 'date',
                    orderable: true
                },
                {
                    label: 'Routes',
                    id: 'routes',
                    name: 'routes',
                    orderable: false
                },
                {
                    label: 'Stops',
                    id: 'stops',
                    name: 'stops',
                    orderable: false
                },
                {
                    label: 'KMs',
                    id: 'distance',
                    name: 'distance',
                    orderable: false
                },
                {
                    label: 'KMs/stop',
                    id: 'distancePerStop',
                    name: 'distancePerStop',
                    orderable: false
                },
                {
                    label: 'Revenue',
                    id: 'revenue',
                    name: 'revenue',
                    orderable: false
                },
                {
                    label: 'Revenue/stop',
                    id: 'revenuePerStop',
                    name: 'revenuePerStop',
                    orderable: false
                },
                {
                    label: 'Revenue/KM',
                    id: 'revenuePerDistanceUnit',
                    name: 'revenuePerDistanceUnit',
                    orderable: false
                },
                // {
                //     label: 'Cost',
                //     id: 'cost',
                //     // name: 'cost',
                //     orderable: false
                // },
                {
                    label: 'Total Cost',
                    id: 'costWithFees',
                    // name: 'costWithFees',
                    orderable: false
                },
                {
                    label: 'Included Fees',
                    id: 'driverFeesJsonTotal',
                    // name: 'driverFeesJsonTotal',
                    orderable: false
                },
                {
                    label: 'Included Bonuses',
                    id: 'driverBonusesJsonTotal',
                    // name: 'driverBonusesJsonTotal',
                    orderable: false
                },
                {
                    label: 'Profit',
                    id: 'profitWithFees',
                    // name: 'profitWithFees',
                    orderable: false
                },
            ],
            filters: {
                dateFrom: '',
                dateTo: '',
                types: [],
                length: 25,
                column: 'date',
                dir: 'desc',
            },
            classes: {
                'table-container': {
                    'justify-center': true,
                    'w-full': true,
                    'flex': true,
                    'rounded-lg': true,
                    'mb-4': true,
                    'shadow-md': true,
                    'border': true,
                    'overflow-hidden': true
                },
                table: {
                    'text-left': true,
                    'w-full': true,
                    'border-collapse': true,
                    'table': true,
                    'table-striped': true,
                    'border': false,
                    'mb-0': true
                },
                't-head': {
                    'text-grey-dark': true,
                    'bg-black': true,
                    'border-grey-light': true,
                    'py-4': true,
                    'px-6': true,
                    'border': false,
                    'bg-white': true,
                },
                "t-body": {
                    'bg-grey-darkest': true,
                    'border-0': true,
                },
                "th": {
                    'border-left-0': true,
                    'border-right': true,
                    'border-bottom-0': true,
                    'border-top-0': true,
                    'shadow-sm': true,
                    'position-relative': true,
                    'font-weight-semi-bold': true,
                    'h6': true,
                    'text-left': true,

                },
                "td": {
                    'py-1': true,
                    'border-0': true,
                    'laravel-vue-datatable-td': false,
                }
            },
            translate: {
                nextButton: '',
                previousButton: '',
                placeholderSearch: 'Search for ID'
            },
            typeOptions: [],
        }
    },
    methods: {
        sort(key) {
            if (key) {
                this.columns.forEach((column) => {
                    if (column.id === key && column.orderable) {
                        this.filters.column = key;
                        this.filters.dir = this.filters.dir === 'asc' ? 'desc' : 'asc';
                    }
                });
            }
        },
        rowShouldIncludeDriverFees(item) {
            // Excluding "Planned" calculation from adding driver fees
            return ((this.types[item.type] && this.types[item.type].name_alt) || '').toLowerCase().includes('executed');
        },
        getPriceHoverTitle(item) {
            return item.cost +  (item.driverFeesTotal >= 0 ? '+' : '-')  + Math.abs(item.driverFeesTotal);
        },
        getProfitHoverTitle(item) {
            return item.profit +  (item.driverFeesTotal >= 0 ? '-' : '+')  + Math.abs(item.driverFeesTotal);
        }
    },
    mounted() {

    },
    created() {
        for (let i in this.types) {
            this.types[i]['key'] = i;
            this.types[i]['label'] = `${this.types[i]['name']} (${this.types[i]['time']})`;
            this.typeOptions.push(this.types[i])
        }
    },
}
</script>
<style scoped>

</style>
